export enum FilterTypePeriod {
	NONE,
	TODAY,
	BIWEEKLY,
	MONTHLY,
	CUSTOM
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/models/filter-type-period.enum.ts